import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const PaymentCancelled = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleRetry = () => {
    navigate("/payment");
  };

  return (
    <div id="login-container">
      <div className="container">
        <div className="col-md-12">
          <div id="login-content">
            <div className="card card-container auth-status-card">
              <div className="auth-status-icon danger"><i className="icon-close" /></div>
              <div id="content-title">
                {t('Payment Cancelled')}
              </div>
              
              <div className="auth-lead">
                <p>
                  {t('Your payment was cancelled. No charges have been made to your account.')}
                </p>
                <p>
                  {t('If you would like to subscribe to Risqui, please try again.')}
                </p>
              </div>

              <button 
                className="btn btn-outline-primary btn-block login-submit"
                onClick={handleRetry}
              >
                {t('Try Again')}
              </button>

              <div className="auth-footnote">
                <p>
                  {t('Need help? Contact us at')}{' '}
                  <a href="mailto:info@risqui.nl">info@risqui.nl</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancelled;
